export class PastasModel {
  idcampanhas: number = 0;
  idpastas: number = 0;
  descricao: string = "";
  habilitado: boolean = true;
}